import { useEffect, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfGarage, ModelOfGarageMonth } from 'src/database';
import api from 'src/services/api';

export const useGarageController = () => {
	const { userAgencyId } = useAuth();
	const [loading, setLoading] = useState(false);
	const [loadingMonth, setLoadingMonth] = useState(false);
	const [garageData, setGarageData] = useState<ModelOfGarage | null>(null);
	const [garageDataMonth, setGarageDataMonth] = useState<ModelOfGarageMonth | null>(null);

	const getDashboardData = () => {
		setLoading(true);

		api.get(`garage-dashboard/${userAgencyId}`)
			.then((response) => {
				setGarageData(response.data);
				setLoading(false);
			})
			.catch((err) => {
				console.log(err);
				setLoading(false);
			});
	};

	const getDashboardMonthData = (year: number) => {
		setLoadingMonth(true);

		api.get(`garage-dashboard-month/${userAgencyId}/${year}`)
			.then((response) => {
				setGarageDataMonth(response.data);
				setLoadingMonth(false);
			})
			.catch((err) => {
				console.log(err);
				setLoadingMonth(false);
			});
	};

	useEffect(() => {
		getDashboardData();
		getDashboardMonthData(new Date().getFullYear());
	}, []);

	return {
		getGarageDashboard: {
			loading,
			loadingMonth,
			garageData,
			garageDataMonth,
		},
		handleGarageDashboard: {
			getDashboardData,
			getDashboardMonthData,
		},
	};
};
